import { render, staticRenderFns } from "./Fournisseur.vue?vue&type=template&id=b02baebc&"
import script from "./Fournisseur.vue?vue&type=script&lang=ts&"
export * from "./Fournisseur.vue?vue&type=script&lang=ts&"
import style0 from "./Fournisseur.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports